import { formatMonthYear } from '@/utils/format';

/**
 * How each kind of proposal is worded on the review screen.
 *
 * Separate from the component that draws them so a list can render education,
 * experience or certificates without three near-identical components -- and so
 * the file holding the component holds only the component.
 */

/** "June 2024 – September 2024", or "June 2024 – now". */
export function dateRange(item) {
  if (!item.start_date) return null;
  const start = formatMonthYear(item.start_date);
  const end = item.is_current ? 'now' : formatMonthYear(item.end_date);
  return end ? `${start} – ${end}` : start;
}

export function renderEducation(item) {
  return {
    heading: item.institution ?? 'Unnamed institution',
    subheading: [item.degree, item.field_of_study].filter(Boolean).join(', ') || null,
    detail: [dateRange(item), item.grade].filter(Boolean).join(' · ') || null,
  };
}

export function renderExperience(item) {
  const dates = dateRange(item);
  return {
    heading: item.title ?? 'Untitled role',
    subheading: [item.company, item.location].filter(Boolean).join(' · ') || null,
    // The CV said "Present", but the profile already has a newer current
    // job: say why an end date appeared rather than leave it unexplained.
    detail: item.ended_by
      ? `${dates} · your CV says "Present", but it ended when ${item.ended_by} began`
      : dates,
  };
}

/**
 * A project read from the CV, offered as a portfolio item. The dates are shown
 * to tell projects apart; the portfolio itself does not keep them.
 */
export function renderProject(item) {
  return {
    heading: item.title ?? 'Untitled project',
    subheading: item.project_url ?? item.repository_url ?? null,
    detail: [dateRange(item), item.description].filter(Boolean).join(' · ') || null,
  };
}

export function renderCertification(item) {
  return {
    heading: item.name ?? 'Unnamed certificate',
    subheading: item.issuer,
    detail: item.issue_date ? formatMonthYear(item.issue_date) : null,
  };
}
